import { CarsLocationSharing } from '../types';

export const MOCK_CARS_LOCATION_SHARING: CarsLocationSharing[] = [
  {
    id: '1a2b3c4d-0001-4e5f-8a9b-000000000001',
    autoNumber: 'AA1234BB',
    historyStartDateUtc: '2026-10-01T00:00:00Z',
    historyEndDateUtc: '2026-10-02T00:00:00Z',
    note: 'Поездка в Минск',
    token: 'tok_0001_aaaaaaaaaaaaaaaa',
    createdAtUtc: '2026-10-01T08:15:00Z',
  },
  {
    id: '1a2b3c4d-0002-4e5f-8a9b-000000000002',
    autoNumber: 'BC5678CD',
    historyStartDateUtc: '2026-10-02T06:00:00Z',
    historyEndDateUtc: '2026-10-15T06:00:00Z',
    note: 'Рейс Брест - Гомель',
    token: 'tok_0002_bbbbbbbbbbbbbbbb',
    createdAtUtc: '2026-10-02T05:45:00Z',
  },
  {
    id: '1a2b3c4d-0003-4e5f-8a9b-000000000003',
    autoNumber: 'EK9012FG',
    historyStartDateUtc: '2026-09-28T00:00:00Z',
    historyEndDateUtc: '2026-09-30T00:00:00Z',
    note: '',
    token: 'tok_0003_cccccccccccccccc',
    createdAtUtc: '2026-09-28T12:00:00Z',
  },
  {
    id: '1a2b3c4d-0004-4e5f-8a9b-000000000004',
    autoNumber: 'HI3456JK',
    historyStartDateUtc: '2026-10-10T00:00:00Z',
    historyEndDateUtc: '2026-10-11T00:00:00Z',
    note: 'Для клиента',
    token: 'tok_0004_dddddddddddddddd',
    createdAtUtc: '2026-10-10T09:30:00Z',
  },
  {
    id: '1a2b3c4d-0005-4e5f-8a9b-000000000005',
    autoNumber: 'LM7890NO',
    historyStartDateUtc: '2026-10-05T00:00:00Z',
    historyEndDateUtc: '2026-10-12T00:00:00Z',
    note: 'Недельный маршрут',
    token: 'tok_0005_eeeeeeeeeeeeeeee',
    createdAtUtc: '2026-10-05T07:00:00Z',
  },
  {
    id: '1a2b3c4d-0006-4e5f-8a9b-000000000006',
    autoNumber: 'PQ1234RS',
    historyStartDateUtc: '2026-10-13T00:00:00Z',
    historyEndDateUtc: '2026-10-14T00:00:00Z',
    note: 'Проверка ссылки',
    token: 'tok_0006_ffffffffffffffff',
    createdAtUtc: '2026-10-13T18:20:00Z',
  },
  {
    id: '1a2b3c4d-0007-4e5f-8a9b-000000000007',
    autoNumber: 'TU5678VW',
    historyStartDateUtc: '2026-09-20T00:00:00Z',
    historyEndDateUtc: '2026-09-21T00:00:00Z',
    note: 'Архивная ссылка',
    token: 'tok_0007_gggggggggggggggg',
    createdAtUtc: '2026-09-20T10:10:00Z',
  },
  {
    id: '1a2b3c4d-0008-4e5f-8a9b-000000000008',
    autoNumber: 'XY9012ZA',
    historyStartDateUtc: '2026-10-07T00:00:00Z',
    historyEndDateUtc: '2026-10-08T00:00:00Z',
    note: 'Для страховой',
    token: 'tok_0008_hhhhhhhhhhhhhhhh',
    createdAtUtc: '2026-10-07T14:40:00Z',
  },
  {
    id: '1a2b3c4d-0009-4e5f-8a9b-000000000009',
    autoNumber: 'BD3456CE',
    historyStartDateUtc: '2026-10-11T00:00:00Z',
    historyEndDateUtc: '2026-10-13T00:00:00Z',
    note: 'Диспетчерская проверка',
    token: 'tok_0009_iiiiiiiiiiiiiiii',
    createdAtUtc: '2026-10-11T06:05:00Z',
  },
  {
    id: '1a2b3c4d-0010-4e5f-8a9b-000000000010',
    autoNumber: 'FG7890HI',
    historyStartDateUtc: '2026-10-09T00:00:00Z',
    historyEndDateUtc: '2026-10-09T12:00:00Z',
    note: 'Короткая смена',
    token: 'tok_0010_jjjjjjjjjjjjjjjj',
    createdAtUtc: '2026-10-09T03:00:00Z',
  },
];
